export default __webpack_public_path__ + "static/cabin-basic-2-to-6-2-7cec1071005dde669f34067aafa1bd63.jpg";